import { render, staticRenderFns } from "./component-region.vue?vue&type=template&id=5b55d7b6"
import script from "./component-region.vue?vue&type=script&lang=js"
export * from "./component-region.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports